<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
        <div class="info-reservation">
          <div class="wrap-info-reservation">
            <div v-if="!$isEmpty($store.state.selected_outlet)" class="wrap-info-reservation-content">
              <div class="info-reservation-title">
                {{ $store.state.selected_outlet.name }}
              </div>
              <div class="info-reservation-subtitle">
                <v-icon size="16" color="#9B9B9B" class="mr-1">
                  mdi-clock-outline
                </v-icon>
                {{ working_hours }}
              </div>
              <div v-if="Number($store.state.selected_outlet.reservation.minimum_order_amount)" class="info-reservation-subtitle">
                <v-icon size="16" color="#9B9B9B" class="mr-1">
                  mdi-cash
                </v-icon>
                Minimal order <span v-mask-money="$store.state.selected_outlet.reservation.minimum_order_amount" class="ml-1" />
              </div>
            </div>
            <div class="ml-3">
              <div class="primary--text text-non-direction font-weight-bold cursor-pointer" @click="sheetTerm = true">
                Lihat Ketentuan
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="mt-5">
          <div class="mb-6">
            <v-dialog ref="dialog_date" v-model="dialog.date" :return-value.sync="sendToForm.reserve_date" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <label class="l-input">Tanggal</label>
                <v-text-field v-model="computedDateFormatted" prepend-inner-icon="mdi-calendar" hide-details dense readonly outlined v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="sendToForm.reserve_date" scrollable :min="minDate">
                <v-spacer />
                <v-btn text color="primary" class="text-none" @click="dialog.date = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" class="text-none" @click="selectDate()">
                  Ok
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="mb-6">
            <label class="l-input">Pukul</label>
            <!-- <ValidationProvider v-slot="{ errors }" name="reserve_time" :rules="{ required: true, reserveTime: { reserve_hour, reserve_minute }}">
              <v-text-field v-model="sendToForm.reserve_time" placeholder="Pilih waktu reservasi" readonly outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense class="input-reserve-time" @click="openDialogTime" />
            </ValidationProvider> -->
            <ValidationProvider v-slot="{ errors }" name="reserve_time" :rules="{ required: true }">
              <!-- <v-text-field v-model="sendToForm.reserve_time" placeholder="Pilih waktu reservasi" readonly outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense class="input-reserve-time" @click="openDialogTime" /> -->
              <v-select v-model="sendToForm.reserve_time" :placeholder="!time_disabled ? 'Pilih waktu reservasi' : 'Jam reservasi tidak tersedia'" :items="list_hour" outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense :disabled="time_disabled" class="input-reserve-time" @change="selectTime()" />
            </ValidationProvider>
            <div v-if="availability_slot > 0" class="guest-availability-slot">
              <span v-if="!guestStore">
                Tersedia untuk {{ availability_slot }} meja
              </span>
              <span v-else>
                Tersedia untuk {{ availability_slot }} pengunjung
              </span>
            </div>
          </div>
          <template v-if="!time_disabled">
            <div class="text-center">
              <div v-if="!guestStore" class="font-16 grey--text">
                Jumlah Meja
              </div>
              <div v-else class="font-16 grey--text">
                Jumlah Kursi
              </div>
            </div>
            <div class="d-flex align-center justify-center py-4">
              <v-btn color="primary" fab outlined small :disabled="disabled" @click="sendToForm.total_guest = sendToForm.total_guest - 1">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <h1 class="display-3 px-5 font-weight-medium">
                {{ sendToForm.total_guest }}
              </h1>
              <v-btn color="primary" fab outlined small @click="sendToForm.total_guest = sendToForm.total_guest + 1">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
            <!-- hide request pak ali melalui group support pada tanggl 24 februari 2025 -->
            <!-- <div class="mt-4 text-center">
              <div class="font-12  grey--text">
                1 Meja bisa untuk 4 pengunjung
              </div>
            </div> -->
          </template>
          <template v-else>
            <div class="list-with-icon list-limit-table">
              <div class="list-item-icon mr-2">
                <v-icon color="#FF931E" size="20">
                  mdi-alert-outline
                </v-icon>
              </div>
              <div class="list-item-content">
                <div class="list-item-text">
                  Jam reservasi tidak tersedia di tanggal terpilih. Coba pilih tanggal lain.
                </div>
              </div>
            </div>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <div class="__menu-bottom menu-full">
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
            <v-btn type="submit" :disabled="availability_slot <= 0" color="primary" block x-large class="text-none" @click="selectMenu">
              Pilih menu
            </v-btn>
          </v-col>
        </div>
      </v-row>
    </ValidationObserver>

    <div v-if="dialog.reserve_time" class="reserve-overlay" />

    <div v-if="dialog.reserve_time" class="reserve-dialog">
      <div class="reserve-dialog-wrap">
        <v-card>
          <v-card-text class="pa-4">
            <div class="d-flex align-center mb-5">
              <div class="font-16 black--text">
                Pilih waktu
              </div>
              <v-spacer />
              <v-btn icon size="28" @click="dialog.reserve_time = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
            <div class="px-2">
              <div class="d-flex align-center justify-center">
                <div class="text-reserve-time">
                  Jam
                </div>
                <div class="text-reserve-time">
                  Menit
                </div>
              </div>
              <scroll-picker-group class="d-flex">
                <scroll-picker v-model="reserve_hour" :options="list_hours" />
                <scroll-picker v-model="reserve_minute" :options="list_minutes" />
              </scroll-picker-group>
            </div>
            <v-btn block large depressed color="primary" class="text-none" @click="selectTime()">
              Pilih
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="dialog.max_visitor" max-width="320">
      <v-card>
        <v-card-text class="pt-8">
          <div class="mb-6">
            <v-img src="@/assets/images/svg/max_visitor.svg" width="166" height="166" class="mx-auto" />
          </div>
          <div class="text-center">
            <div class="title-dialog">
              Tidak cukup Meja untuk Reservasi :(
            </div>
            <div class="subtitle-dialog mt-4">
              Jumlah Meja yang dimasukan melebihi Meja yang tersedia. Hubungi pihak resto untuk detail Reservasi.
            </div>
          </div>
          <v-btn block large depressed color="primary" class="text-none mt-6" @click="dialog.max_visitor = false">
            Ya, saya mengerti
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="sheetTerm" persistent :content-class="'sheet-full'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
              <div class="d-flex align-center py-3 px-6">
                <h2 class="font-20">
                  <span class="font-weight-bold d-flex align-center">
                    Ketentuan
                  </span>
                </h2>
                <v-spacer />
                <v-btn text icon @click="sheetTerm = false">
                  <v-icon class="black--text">
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="info-reservation">
                <div class="pa-4 text-center">
                  <div class="banner-reservation-logo">
                    <template v-if="$store.state.selected_outlet">
                      <img :src="$store.state.selected_outlet.logo" alt="Logo">
                    </template>
                  </div>
                  <div class="banner-text">
                    <template v-if="$store.state.selected_outlet">
                      {{ $store.state.selected_outlet.name }}
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="$store.state.selected_outlet && !$isEmpty($store.state.selected_outlet.setting)">
                <div class="mt-6 font-14" v-html="$store.state.selected_outlet.setting.tnc_store_content" />
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { getLocale } from '@/utils/locale'
import {
  checkReserve as checkReserveTime,
  reserveTimes as getReserveTime
} from '@/api/setting'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      reserve_hour: 0,
      reserve_minute: 0,
      list_hours: [],
      list_minutes: [],
      sheetTerm: false,
      dialog: {
        date: false,
        max_visitor: false,
        reserve_time: false
      },
      min_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      disabled: true,
      time_disabled: false,
      sendToForm: {
        total_guest: 1,
        reserve_time: '',
        reserve_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        item: []
      },
      availability_slot: 0,
      working_hours: '00:00 - 24:00',
      data_reserve: {},
      guest_store: [
        'seiasekataespressobar',
        'minimizecoffee'
      ]
    }
  },
  computed: {
    guestStore() {
      const url = this.$store.state.url_domain
      if (this.guest_store.indexOf(url) !== -1) {
        return true
      } else {
        return false
      }
    },
    computedDateFormatted() {
      return this.formatDate(this.sendToForm.reserve_date)
    },
    minDate() {
      if (!this.$isEmpty(this.data_reserve)) {
        if (Number(this.data_reserve.type_time_reservation) === 1) {
          if (Number(this.data_reserve.maximum_time_for_reservation_type) === 0) {
            var date = new Date()
            date.setDate(date.getDate() + this.data_reserve.maximum_time_for_reservation)
            const max_date = date.toISOString().substr(0, 10)
            return max_date
          } else {
            return this.min_date
          }
        } else {
          return this.min_date
        }
      } else {
        return this.min_date
      }
    },
    list_hour() {
      const list = []
      if (!this.$isEmpty(this.data_reserve) && this.data_reserve.reservation_time_in_date.length > 0) {
        this.data_reserve.reservation_time_in_date.map((item) => {
          item.split_times.map((time) => {
            if (time.time_has_passed === 0) {
              list.push(time.fstart_time)
            }
          })
        })
      }
      return list
    }
  },
  watch: {
    'reserve_hour': async function(newItem) {
      var listminutes = []
      if (Number(newItem)) {
        if (!this.$isEmpty(this.data_reserve)) {
          let first_minute = 0
          let last_minute = 59
          const item = this.data_reserve.reservation_time_in_date
          for (let i = 0; i < item.length; i++) {
            const arrStartTime = item[i].fstart_time.split(':')
            const arrEndTime = item[i].fend_time.split(':')
            if (this.sendToForm.reserve_date === (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)) {
              const d = new Date()
              const t_hour = d.getHours()
              const t_minute = d.getMinutes()
              let currhours = t_hour
              let currminutes = t_minute
              if (Number(this.data_reserve.type_time_reservation) === 1 && Number(this.data_reserve.maximum_time_for_reservation_type) === 1) {
                const arrTimeReserve = this.timeConvert(this.data_reserve.maximum_time_for_reservation)
                currhours = t_hour + arrTimeReserve[0]
                if ((arrTimeReserve[1] + t_minute) > 60) {
                  const arrExTime = this.timeConvert((arrTimeReserve[1] + t_minute))
                  currhours = currhours + arrExTime[0]
                  currminutes = arrExTime[1]
                } else {
                  currminutes = currminutes + arrTimeReserve[1]
                }

                if (Number(newItem) === currhours) {
                  if (Number(newItem) <= Number(arrStartTime[0]) && Number(newItem) === Number(arrEndTime[0])) {
                    if (currminutes > Number(arrStartTime[1])) {
                      first_minute = currminutes
                      last_minute = Number(arrEndTime[1])
                      break
                    } else {
                      first_minute = Number(arrStartTime[1])
                      last_minute = Number(arrEndTime[1])
                      break
                    }
                  } else if (Number(newItem) <= Number(arrStartTime[0])) {
                    if (currminutes > Number(arrStartTime[1])) {
                      first_minute = currminutes
                      break
                    } else {
                      first_minute = Number(arrStartTime[1])
                      break
                    }
                  } else {
                    first_minute = currminutes
                    break
                  }
                } else {
                  if (Number(newItem) === Number(arrStartTime[0]) && Number(newItem) === Number(arrEndTime[0])) {
                    first_minute = Number(arrStartTime[1])
                    last_minute = Number(arrEndTime[1])
                    break
                  } else if (Number(newItem) === Number(arrStartTime[0])) {
                    first_minute = Number(arrStartTime[1])
                    break
                  } else if (Number(newItem) === Number(arrEndTime[0])) {
                    last_minute = Number(arrEndTime[1])
                    break
                  }
                }
              }
            } else {
              if (Number(newItem) === Number(arrStartTime[0]) && Number(newItem) === Number(arrEndTime[0])) {
                first_minute = Number(arrStartTime[1])
                last_minute = Number(arrEndTime[1])
                break
              } else if (Number(newItem) === Number(arrStartTime[0])) {
                first_minute = Number(arrStartTime[1])
                break
              } else if (Number(newItem) === Number(arrEndTime[0])) {
                last_minute = Number(arrEndTime[1])
                break
              }
            }
          }
          for (let i = first_minute; i < (last_minute + 1); i++) {
            listminutes.push({
              value: i < 10 ? '0' + i : i.toString(),
              name: i < 10 ? '0' + i : i.toString()
            })
          }
        }
      }
      if (listminutes.length > 0) {
        this.list_minutes = await listminutes
      } else {
        this.list_minutes = []
      }
    },
    'dialog.reserve_time': function(newItem) {
      const root = document.getElementsByTagName('html')[0]
      if (newItem) {
        root.setAttribute('class', 'overflow-y-hidden')
        this.getListHours()
      } else {
        root.classList.remove('overflow-y-hidden')
      }
    },
    sendToForm: {
      handler: function(newItem) {
        if (newItem.total_guest > 1) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      },
      deep: true
    },
    minDate(newItem) {
      this.sendToForm.reserve_date = newItem
      this.getTimes()
    }
  },
  mounted() {
    this.getWorkingHours()
    this.getTimes()
  },
  methods: {
    async getListHours() {
      var listhours = []
      if (!this.$isEmpty(this.data_reserve)) {
        this.data_reserve.reservation_time_in_date.map(item => {
          const arrStartTime = item.fstart_time.split(':')
          const arrEndTime = item.fend_time.split(':')
          if (this.sendToForm.reserve_date === (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)) {
            const d = new Date()
            const t_hour = d.getHours()
            const t_minute = d.getMinutes()
            let currhours = t_hour
            if (Number(this.data_reserve.type_time_reservation) === 1 && Number(this.data_reserve.maximum_time_for_reservation_type) === 1) {
              const arrTimeReserve = this.timeConvert(this.data_reserve.maximum_time_for_reservation)
              currhours = t_hour + arrTimeReserve[0]
              if ((arrTimeReserve[1] + t_minute) > 60) {
                const arrExTime = this.timeConvert((arrTimeReserve[1] + t_minute))
                currhours = currhours + arrExTime[0]
              }
            }
            for (let i = Number(arrStartTime[0]); i < (Number(arrEndTime[0]) + 1); i++) {
              if (i >= currhours) {
                listhours.push({
                  value: i < 10 ? '0' + i : i.toString(),
                  name: i < 10 ? '0' + i : i.toString()
                })
              }
            }
          } else {
            for (let i = Number(arrStartTime[0]); i < (Number(arrEndTime[0]) + 1); i++) {
              listhours.push({
                value: i < 10 ? '0' + i : i.toString(),
                name: i < 10 ? '0' + i : i.toString()
              })
            }
          }
        })
      }
      this.list_hours = await listhours
      if (listhours.length > 0) {
        this.reserve_hour = await listhours[0].value
      }
    },
    timeConvert(n) {
      const num = n
      const hours = (num / 60)
      const rhours = Math.floor(hours)
      const minutes = (hours - rhours) * 60
      const rminutes = Math.round(minutes)
      return [rhours, rminutes]
    },
    async selectMenu() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        if (this.availability_slot >= this.sendToForm.total_guest) {
          this.$store.dispatch('saveDataCartReservation', this.sendToForm)
          this.$router.push({ name: 'reservation_menu' }).catch(() => {})
        } else {
          this.dialog.max_visitor = true
        }
      }
    },
    getWorkingHours() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const selected_store = this.$store.state.selected_outlet
        const today = new Date()
        const curTd = today.getDay()
        if (curTd === 0) {
          this.working_time = selected_store.working_hours[6]
        } else {
          this.working_time = selected_store.working_hours[curTd - 1]
        }
        if (this.working_time.times.length > 0) {
          this.working_hours = this.working_time.times[0].fstart_time + ' - ' + this.working_time.times[this.working_time.times.length - 1].fend_time
        }
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      var selectedlocale = getLocale()
      if (selectedlocale === undefined || selectedlocale == null) {
        selectedlocale = process.env.VUE_APP_I18N_LOCALE
      }
      let month_name = ''
      if (selectedlocale === 'id') {
        if (month === '01') {
          month_name = 'Januari'
        } else if (month === '02') {
          month_name = 'Februari'
        } else if (month === '03') {
          month_name = 'Maret'
        } else if (month === '04') {
          month_name = 'April'
        } else if (month === '05') {
          month_name = 'Mei'
        } else if (month === '06') {
          month_name = 'Juni'
        } else if (month === '07') {
          month_name = 'Juli'
        } else if (month === '08') {
          month_name = 'Agustus'
        } else if (month === '09') {
          month_name = 'September'
        } else if (month === '10') {
          month_name = 'Oktober'
        } else if (month === '11') {
          month_name = 'November'
        } else {
          month_name = 'Desember'
        }
      } else {
        if (month === '01') {
          month_name = 'January'
        } else if (month === '02') {
          month_name = 'February'
        } else if (month === '03') {
          month_name = 'March'
        } else if (month === '04') {
          month_name = 'April'
        } else if (month === '05') {
          month_name = 'May'
        } else if (month === '06') {
          month_name = 'June'
        } else if (month === '07') {
          month_name = 'July'
        } else if (month === '08') {
          month_name = 'August'
        } else if (month === '09') {
          month_name = 'September'
        } else if (month === '10') {
          month_name = 'October'
        } else if (month === '11') {
          month_name = 'November'
        } else {
          month_name = 'December'
        }
      }
      return `${day} ${month_name} ${year}`
    },
    async getTimes() {
      this.time_disabled = false
      try {
        const params = {
          reserve_date: this.sendToForm.reserve_date
        }
        const { data } = await getReserveTime(params)
        this.$store.state.loading_axios = false
        this.data_reserve = data.data
        if (this.data_reserve.reservation_time_in_date.length === 0) {
          this.time_disabled = true
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    selectDate() {
      this.$refs.dialog_date.save(this.sendToForm.reserve_date)
      this.sendToForm.reserve_time = ''
      this.availability_slot = 0
      this.getTimes()
    },
    openDialogTime() {
      this.dialog.reserve_time = true
    },
    async selectTime() {
      try {
        const form = {
          // time: this.reserve_hour + ':' + this.reserve_minute
          time: this.sendToForm.reserve_time,
          reserve_date: this.sendToForm.reserve_date
        }
        const { data } = await checkReserveTime(form)
        this.$store.state.loading_axios = false
        this.availability_slot = data.data.availability_slot
        this.dialog.reserve_time = false
        if (this.reserve_hour && this.reserve_minute) {
          this.sendToForm.reserve_time = this.reserve_hour + ':' + this.reserve_minute
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
